/**
 * A user's picked filter selection — the currency of the picker draft state,
 * committed to `userSelection.filters`, and the input to the wire adapters.
 * Discriminated union: `kind` narrows to exactly one of `options` or `range`.
 */
export type FilterKind = 'OPTION' | 'RANGE';

export type FilterSelection =
  | {
      code: string;              // ULID (BootstrapFilter.code)
      kind: 'OPTION';
      options: string[];         // ULID option codes (BootstrapFilterOption.code[])
    }
  | {
      code: string;
      kind: 'RANGE';
      range: { min: number; max: number };
    };

export function isOptionSelection(
  s: FilterSelection,
): s is Extract<FilterSelection, { kind: 'OPTION' }> {
  return s.kind === 'OPTION';
}

export function isRangeSelection(
  s: FilterSelection,
): s is Extract<FilterSelection, { kind: 'RANGE' }> {
  return s.kind === 'RANGE';
}
